module.exports = __webpack_public_path__ + "static/media/DKP.5faa88b9.jpg";